module.exports = __webpack_public_path__ + "img/pigduck.37a6bcfd.jpg";